import { flow } from 'lodash-es';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { PersonalizedSearchModel, PersonalizedSearchPaths } from 'client/data/models/personalized-search';
import { VisitorModel } from 'client/data/models/visitor';
import { PageModel } from 'client/data/models/page';

const stateToPropsConfig = {
  zipCode: bindToPath('location.zipCode', VisitorModel),
  visitorLocation: bindToPath('location', VisitorModel, null, false),
  selectedFilters: bindToPath(PersonalizedSearchPaths.getSelectedFilters(), PersonalizedSearchModel, null, false),
  location: bindToPath('location', PageModel, null, false),
};

export const inventoryDataProvider = flow([
  component =>
    connectToModel(component, {
      inventoryData: bindToPath(
        ({ selectedFilters }) => !!selectedFilters && PersonalizedSearchPaths.getInventoryData(),
        PersonalizedSearchModel,
        null,
        false
      ),
    }),
  component => connectToModel(component, stateToPropsConfig),
]);
